// extracted by mini-css-extract-plugin
export default {"root":"CqoZXG","button":"SAjB8D","title":"etv7w4","paragraph":"YW6w7o"};